import { Component, OnInit } from "@angular/core";
import {
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
  PageViewModel,
} from "src/domain/client";
import { MediaPipe } from "src/pipes/media.pipe";
import { BrandService } from "src/services/brand.service";
import { ErrorReporterService } from "src/services/error-reporter.service";
import { PageService } from "src/services/page.service";

@Component({
  selector: "vw-not-found-page",
  templateUrl: "./not-found-page.component.html",
})
export class NotFoundPageComponent implements OnInit {
  loading = false;
  page?: PageViewModel;
  title = "";
  body = "";

  constructor(
    private pageService: PageService,
    private errorReporter: ErrorReporterService,
    private brandService: BrandService,
    private mediaPipe: MediaPipe,
  ) {}

  ngOnInit(): void {
    this.getNotFoundPage();
  }

  //////////

  private getNotFoundPage(): void {
    this.loading = true;

    this.pageService
      .getNotFoundPage(this.brandService.brandId)
      .then((page) => {
        this.page = page;
        this.setMedia();
      })
      .catch(this.errorReporter.handle)
      .finally(() => {
        this.loading = false;
      });
  }

  private setMedia(): void {
    this.title = this.mediaPipe.transform(
      this.page?.media,
      MediaCategoryTypeNameEnum.Title,
      MediaTypeNameEnum.Text,
    );

    this.body = this.mediaPipe.transform(
      this.page?.media,
      MediaCategoryTypeNameEnum.Body,
      MediaTypeNameEnum.HTML,
    );
  }
}
